import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
  Tag,
  //StarRating,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import LiveDemoDetail from "./LiveDemoDetail";
import MMContentDetail from "./MMContentDetail";
import Rating from "@material-ui/lab/Rating";
import ScaleLoader from "react-spinners/ScaleLoader";

class MMListViewCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MMContent: this.props._mmcontent,
      bShowMMDetail: false,
      showLoaderRating: false,
    };
    this._showMMDetail = this._showMMDetail.bind(this);
    this._hideMMDetail = this._hideMMDetail.bind(this);
    this.setRating = this.setRating.bind(this);
  }

  componentDidMount() {}

  _showMMDetail() {
    //console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowMMDetail: true });
  }
  _hideMMDetail() {
    this.setState({ bShowMMDetail: false });
    this.props.hide();
  }

  setRating(newRate, type, id, rating) {
    console.log("Rating Prop is ", this.props._mmcontent);
    console.log("Rating new Values is ", newRate);
    console.log("Rating new Values Type ", type);
    console.log("Rating new Values ID ", id);
    console.log("Rating  Curent Rate is ", rating);

    if (newRate !== null) {
      // console.log("Rating content Index Val is ", this.props.indexval);

      // var tempdemoData  = this.state.Demo;
      var ActionType = "";
      if (this.props._mmcontent.Content_Rating > 0) {
        ActionType = "Update";
      } else {
        ActionType = "Insert";
      }

      var RatingDataPost = {
        Rating_ID: null,
        ContentId: id,
        Rating_Value: newRate,
        Action_Type: ActionType,
        Content_Type: type,
      };

      var endpoint = "/AllContent/AddorUpdateRating";
      let token = auth.getToken();
      var postData = RatingDataPost;
      console.log("Rating Data is :", RatingDataPost);
      this.setState({ showLoaderRating: true });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log(
          "Profile result Rating insert update response from API:",
          data
        );
        if (data) {
          console.log("UpdateMessage back from Rating Call response is : ");
          console.log(data);

          //  this.props.hide();
          var tempMMData = this.state.MMContent;

          if (tempMMData != undefined) {
            tempMMData.Content_Rating = newRate;
            /*           tempdemoData.map((demoitem) => {
            if(demoitem.Content_ID == contentID){
              demoitem.Content_Rating = newRate;
            }
          }); */
            this.setState({ MMContent: tempMMData, showLoaderRating: false });
          }

          //this.setState({ Demo: tempdemoData, showLoaderRating: false });
          // auth.updateUserInfo(data);
          // this.props.hidenaa();
          // this.props.history.push("/home");
          //this.props.router.replace("/home");
        }
      });
    } else {
      console.log("No Action on Rating as no change in last value");
    }
  }

  render() {
    var MMCont = this.state.MMContent
      ? this.state.MMContent
      : this.props._mmcontent;

    var bShowDetailPopup = false;
    bShowDetailPopup = this.state.bShowMMDetail;
    return (
      <Card
        pad="xsmall"
        justify="between"
        height="small"
        background={{ color: "white" }}
      >
        <Box
          align="stretch"
          justify="start"
          direction="row"
          responsive={false}
          pad="xsmall"
          gap="xsmall"
          round="xsmall"
          background={{ opacity: "medium" }}
        >
          <Box align="center" justify="start" direction="column">
            <Text weight="bold" color="black" truncate={false} size="medium">
              {MMCont.Content_Title}
            </Text>
          </Box>
        </Box>
        <Box
          align="stretch"
          justify="between"
          direction="row"
          responsive={false}
          pad="xsmall"
        >
          <Box
            pad="small"
            border={{ color: "brand", size: "small" }}
            round
            alignSelf="start"
          >
            {"Video"}
          </Box>
          <Box
            pad="small"
            border={{ color: "brand", size: "small" }}
            round
            alignSelf="start"
          >
            {MMCont.Content_ExpertiseLevel
              ? MMCont.Content_ExpertiseLevel.ExpertLevelName
              : "No Expertise"}
          </Box>
        </Box>
        <Box
          align="stretch"
          justify="between"
          direction="row"
          responsive={false}
          pad="xsmall"
        >
          <Button label="Play" icon={<Play />} primary />
          {/* <StarRating /> */}
        </Box>
      </Card>
    );
  }
}

export default MMListViewCard;
